import * as types from "../actions/ActionTypes";
import { Signer, Cipher } from "@flixxo/authorizator";

const defaultState = {
  isLoging: false,
  loginError: null,
  isRegistering: false,
  isRegistered: false,
  registerError: {},
  isConfirming: false,
  isConfirmed: false,
  confirmCodeError: {},
  forgotCodePending: false,
  forgotCodeFulfilled: false,
  forgotCodeError: null,
  resendCodePending: false,
  resendCodeFulfilled: false,
  resendCodeError: {},
  resetPasswordPending: false,
  resetPasswordFulfilled: false,
  resetPasswordError: null,
  isFailed: false,
  email: "",
  password: "",
  code: "",
  secret: "",
  signer: null,
  cipher: null,
  error: "",
  isModerator: false,
  seriesCreator: false,
  showAlertModal: false,
  showAlertModalType: '',
  showAlertModalOptions: {},
  previousAlertModalType: "",
  showSuccessModal: false,
};

export default function reducer(state = defaultState, action) {
  switch (action.type) {
    case types.LOGIN_PENDING:
      return Object.assign({}, state, {
        isLoging: true,
      });
    case types.LOGIN_FULFILLED:
      return Object.assign({}, state, {
        isLoging: false,
        secret: action.payload.secret,
        isModerator: action.payload.isModerator,
        seriesCreator: action.payload.seriesCreator,
        email: action.meta.email,
        signer: new Signer(action.payload.secret),
        cipher: new Cipher(action.payload.secret),
      });
    case types.LOGIN_REJECTED:
      return Object.assign({}, state, {
        isLoging: false,
        secret: "",
        loginError: action.payload.error,
        signer: null,
        cipher: null,
      });

    case types.REGISTER_PENDING:
      return Object.assign({}, state, {
        isRegistering: true,
      });
    case types.REGISTER_FULFILLED:
      return Object.assign({}, state, {
        isRegistering: false,
        isRegistered: true,
        email: action.meta.email,
        secret: action.payload.secret,
        seriesCreator: action.payload.seriesCreator,
        signer: new Signer(action.payload.secret),
        cipher: new Cipher(action.payload.secret),
      });
    case types.REGISTER_REJECTED:
      return Object.assign({}, state, {
        isRegistering: false,
        registerError: action.payload.response,
      });
    case types.REGISTER_CLEAR_ERROR:
      return Object.assign({}, state, {
        registerError: {},
      });

    case types.CONFIRM_PENDING:
      return Object.assign({}, state, {
        isConfirming: true,
        isFailed: false,
      });
    case types.CONFIRM_FULFILLED:
      // patch
      let confirmed = true;
      let failed = false;
      if (typeof action.payload.success === "boolean" && !action.payload.success) {
        confirmed = false;
        failed = true;
      }

      return Object.assign({}, state, {
        isConfirming: false,
        isRegistered: false,
        isConfirmed: confirmed,
        isFailed: failed,
      });

    case types.CONFIRM_REJECTED:
      return Object.assign({}, state, {
        isConfirming: false,
        confirmCodeError: action.payload.response,
      });

    case types.FORGOT_CODE_PENDING:
      return Object.assign({}, state, {
        forgotCodePending: true,
      });
    case types.FORGOT_CODE_FULFILLED:
      return Object.assign({}, state, {
        forgotCodePending: false,
        forgotCodeFulfilled: true,
        email: action.meta.email,
        forgotCodeError: null,
      });
    case types.FORGOT_CODE_REJECTED:
      return Object.assign({}, state, {
        forgotCodePending: false,
        forgotCodeError: action.payload.error,
      });

    case types.RESEND_CODE_PENDING:
      return Object.assign({}, state, {
        resendCodePending: true,
      });
    case types.RESEND_CODE_FULFILLED:
      return Object.assign({}, state, {
        resendCodePending: false,
        resendCodeFulfilled: true,
      });
    case types.RESEND_CODE_REJECTED:
      return Object.assign({}, state, {
        resendCodePending: false,
        resendCodeError: action.payload.response,
      });

    case types.RESET_PASSWORD_PENDING:
      return Object.assign({}, state, {
        resetPasswordPending: true,
      });
    case types.RESET_PASSWORD_FULFILLED:
      return Object.assign({}, state, {
        resetPasswordPending: false,
        resetPasswordFulfilled: true,
      });
    case types.RESET_PASSWORD_REJECTED:
      return Object.assign({}, state, {
        resetPasswordPending: false,
        resetPasswordError: action.payload,
      });
    case types.HANDLE_LOGIN_VERSION_ERROR_PENDING:
      return Object.assign({}, state, {
        isLoging: true,
        loginError: {},
      });
    case types.HANDLE_LOGIN_VERSION_ERROR_FULFILLED:
      return Object.assign({}, state, {
        isLoging: false,
      });
    case types.HANDLE_LOGIN_VERSION_ERROR_REJECTED:
      return Object.assign({}, state, {
        isLoging: false,
      });
    case types.LOGIN_VERSION_ERROR:
      return Object.assign({}, state, {
        loginError: action.payload,
      });

    case types.ALERT_MODAL_OPEN:
      return {
        ...state,
        showAlertModal: true,
        previousAlertModalType: state.showAlertModalType,
        showAlertModalType: action.payload.type,
        showAlertModalOptions: {
          ...state.showAlertModalOptions,
          ...action.payload.options
        }
      };

    case types.ALERT_MODAL_PREVIOUS:
      return {
        ...state,
        showAlertModalType: action.payload,
      };
    case types.ALERT_MODAL_CLOSE:
      return {
        ...state,
        showAlertModal: false,
      };
    case types.SUCCESS_MODAL_OPEN:
      return {
        ...state,
        showSuccessModal: true,
      };
    case types.SUCCESS_MODAL_CLOSE:
      return {
        ...state,
        showSuccessModal: false,
      };

    case "LOGOUT":
      return defaultState;

    default:
      return state;
  }
}
